module.exports = __webpack_public_path__ + "fonts/fa-solid-900.8e4a6dcc.eot";